import { useNavigate } from "react-router-dom";
import {
  publisherAgreementSections,
  PUBLISHER_AGREEMENT_LAST_UPDATED,
} from "../content/publisherAgreementSections";
import {
  applyAgreementAcceptanceToDraft,
  buildAgreementAcceptReturnState,
  loadPublishFormDraft,
  PUBLISH_YOUR_APP_ROUTE,
  savePublishFormDraft,
} from "../services/publisherAgreementFlow";

export function PrivacyPoliciesPage() {
  const navigate = useNavigate();

  function handleAccept() {
    const draft = loadPublishFormDraft();
    if (draft) {
      savePublishFormDraft(applyAgreementAcceptanceToDraft(draft));
    }

    navigate(PUBLISH_YOUR_APP_ROUTE, {
      state: buildAgreementAcceptReturnState(),
    });
  }

  return (
    <article className="oac-publisher-agreement">
      <h1 className="oac-publisher-agreement__heading oac-membership-page__heading">
        <span className="oac-publisher-agreement__heading-desktop">
          Publisher Agreement
        </span>
        <span className="oac-publisher-agreement__heading-mobile">
          <span className="oac-publisher-agreement__heading-mobile-line">
            Publisher
          </span>
          <span className="oac-publisher-agreement__heading-mobile-line">
            Agreement
          </span>
        </span>
      </h1>

      <p className="oac-publisher-agreement__date">
        Last Updated: {PUBLISHER_AGREEMENT_LAST_UPDATED}
      </p>

      <div
        className="oac-publisher-agreement__document app-scroll"
        tabIndex={0}
      >
        {publisherAgreementSections.map((section) => (
          <section
            aria-labelledby={`publisher-agreement-section-${section.number}`}
            className="oac-publisher-agreement__section"
            key={section.number}
          >
            <h2
              className="oac-publisher-agreement__section-title"
              id={`publisher-agreement-section-${section.number}`}
            >
              {section.number}. {section.title}
            </h2>

            {section.paragraphs.map((paragraph) => (
              <p
                className="oac-publisher-agreement__paragraph"
                key={paragraph}
              >
                {paragraph}
              </p>
            ))}

            {section.listItems && (
              <ul className="oac-publisher-agreement__list">
                {section.listItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}

        <div className="oac-publisher-agreement__accept">
          <button
            className="oac-btn oac-btn--blue oac-publisher-agreement__accept-button"
            onClick={handleAccept}
            type="button"
          >
            Accept
          </button>
        </div>
      </div>
    </article>
  );
}
